import React, { useState, useRef, useEffect } from 'react';
import restService from 'services/RestService';
import { Card, Descriptions, Layout, List, Button, Spin } from 'antd';
import { SendOutlined } from '@ant-design/icons';

export const Home = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);

      try{
        let response = await restService.getProductList();
        setIsLoading(false);

        if (response.int_result === 0){
          setProducts(JSON.parse(response.data));
          console.log(JSON.parse(response.data));
        }
      }
      catch(error){
        setIsLoading(false);
      }
    }

    fetchData();
  }, []);

  return (
    <>
      <Layout>
        <Spin tip="Уншиж байна, түр хүлээнэ үү" spinning={isLoading}>
          <List
            grid={{
              gutter: 16,
              xs: 1,
              sm: 2,
              md: 4,
              lg: 4,
              xl: 6,
              xxl: 3,
            }}
            size='large'
            dataSource={products.filter(p => p.SURVEY === "Y")}
            renderItem={(item) => (
              <List.Item>
                <Card
                  title={item.NAME}
                  extra={<Button href={`/request/${item.ID}`} type="primary" icon={<SendOutlined />}>Хүсэлт илгээх</Button>}
                  >
                  <Descriptions bordered size={'small'} column={1} items={[
                    {
                      key: 'INTEREST',
                      label: ((item.PERIOD_TYPE === "MONTH") ? "Сарын" : "Өдрийн") + ' хүү',
                      children: <>
                        {item.INTEREST_MIN}% - {item.INTEREST_MAX}%
                      </>,
                    },
                    {
                      key: 'PERIOD',
                      label: 'Хугацаа',
                      children: <>
                        {item.PERIOD_MIN} - {item.PERIOD_MAX}
                        { item.PERIOD_TYPE === "MONTH" &&
                          " сар"
                        }

                        { item.PERIOD_TYPE === "DAY" &&
                          " өдөр"
                        }
                      </>,
                    },
                    {
                      key: 'AMT',
                      label: 'Зээлийн хэмжээ',
                      children: <>
                        {item.LOAN_MAX.toLocaleString()} хүртэл
                      </>,
                    },
                    {
                      key: 'PREPAID_PRO',
                      label: 'Урьдчилгаа хувь',
                      children: <>
                        {item.PREPAID_PRO}%
                      </>,
                    }
                  ]}>
                    
                  </Descriptions>
                </Card>
              </List.Item>
            )}
          />
        </Spin>
        
      </Layout>
      
    </>
  )
}


export default Home;